module.exports = __webpack_public_path__ + "static/media/CAFE-CARIOCA-pg2.1dd0d372.JPG";